export default __webpack_public_path__ + "static/media/KOD0108-min.13f1810d.webp";